import React from 'react';

const SvgIcManage = (props) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" width="14.638" height="16.102" viewBox="0 0 14.638 16.102">
  <g id="Manage_SVG" data-name="Manage SVG" transform="translate(14.638) rotate(90)">
    <g id="statistics" transform="translate(0 0)">
      <path id="Path_764" data-name="Path 764" d="M2.928,0H1.464A1.468,1.468,0,0,0,0,1.464V5.855A1.468,1.468,0,0,0,1.464,7.319H2.928A1.468,1.468,0,0,0,4.391,5.855V1.464A1.468,1.468,0,0,0,2.928,0Z" transform="translate(0 7.319)" fill="currentColor"/>
      <path id="Path_783" data-name="Path 783" d="M2.928,0H1.464A1.4,1.4,0,0,0,0,1.327v3.98A1.4,1.4,0,0,0,1.464,6.634H2.928A1.4,1.4,0,0,0,4.391,5.307V1.327A1.4,1.4,0,0,0,2.928,0Z" transform="translate(0 0)" fill="currentColor"/>
      <path id="Path_765" data-name="Path 765" d="M2.928,0H1.464A1.468,1.468,0,0,0,0,1.464v11.71a1.468,1.468,0,0,0,1.464,1.464H2.928a1.468,1.468,0,0,0,1.464-1.464V1.464A1.468,1.468,0,0,0,2.928,0Z" transform="translate(5.855)" fill="currentColor"/>
      <path id="Path_766" data-name="Path 766" d="M2.928,0H1.464A1.468,1.468,0,0,0,0,1.464V8.783a1.468,1.468,0,0,0,1.464,1.464H2.928A1.468,1.468,0,0,0,4.391,8.783V1.464A1.468,1.468,0,0,0,2.928,0Z" transform="translate(11.71 4.391)" fill="currentColor"/>
    </g>
  </g>
</svg>
);

export default SvgIcManage;
